import MultiToggle from '../../MultiToggle';
import type { FieldRendererProps } from '../types';

export function MultiToggleField({ field, onChange }: FieldRendererProps) {
  return (
    <MultiToggle
      size="medium"
      defaultValue={field.value}
      hideTitle={false}
      toggleOptions={field.selectOptions}
      onToggle={(value: string) => {
        if (!value) return;
        onChange(value);
      }}
      color="primary"
    />
  );
}
